import Countdown from 'react-countdown'

import type { FC } from 'react'

export interface TimeRemainingProps {
  endTime: Date
  separator?: string
  padding?: boolean
  ticks?: boolean
  callback?: () => void
}

const TimeRemaining: FC<TimeRemainingProps> = ({
  endTime,
  separator = ':',
  padding = true,
  ticks = false,
  callback = () => {},
}) => {
  return (
    <Countdown
      autoStart={ticks}
      date={endTime}
      zeroPadTime={2}
      onComplete={() => callback?.()}
      renderer={({ hours, minutes, seconds }) => (
        <>
          {[
            padding ? `${hours}`.padStart(2, '0') : hours,
            separator,
            padding ? `${minutes}`.padStart(2, '0') : minutes,
            separator,
            padding ? `${seconds}`.padStart(2, '0') : seconds,
          ].join('')}
        </>
      )}
    />
  )
}

export default TimeRemaining
